<!-- pending-feedback-listing.component.html -->
<section class="container mx-auto">
    <div class="md:pt-[50px] sm:pt-[40px] pt-[30px]">
        <div class="flex items-start justify-between gap-2 md:mb-2 sm:mb-5 mb-3">
            <div class="flex items-center gap-2">
                <button class="max-h-[24px]" [routerLink]="'/'">
                    <mat-icon
                        class="mat-18 md:font-bold sm:font-semibold font-semibold text-blue-theme-color">arrow_back</mat-icon>
                </button>
                <h4 class="standard-heading">{{"Pending Feedback"}}</h4>
            </div>
        </div>

        <div class="feedback-container ">
            <div class="feedback-header">

                <!-- Only show Select All when at least one item has a rating -->
                <div class="select-all-container">
                    <label *ngIf="hasAnyRating()">
                        <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                        Select All
                    </label>
                </div>
                <div>
                    <button class="submit-button" (click)="submitFeedback()">Submit</button>
                </div>
            </div>

            <div class="feedback-list">
                <div
                    class="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 md:gap-y-[39px] sm:gap-y-[29px] gap-y-[19px] md:gap-x-[50px] sm:gap-x-[30px] gap-x-[30px]">
                    <div *ngFor="let feedback of feedbackList"
                        class="feedback-item border-b border-gray-color relative cursor-pointer"
                        [class.selected]="feedback.isSelected">
                        <div class="feedback-checkbox justify-between">
                            <div class="flex items-center">
                                <input type="checkbox" [checked]="feedback.isSelected"
                                    (change)="toggleFeedbackSelection(feedback)">
                                <span class="feedback-date">
                                    <i class="material-icons">access_time</i>
                                    {{ feedback.order_date | date: 'MMM d, y - h:mm a' }}
                                </span>

                            </div>

                            <div
                                class="h-[30px] text-[16px] flex justify-center items-center px-4 rounded-md text-white-color bg-[#008000]">
                                Delivered
                            </div>
                        </div>

                        <div class="feedback-content">
                            <div class="feedback-id text-blue-theme-color">#{{ feedback.order_id }}
                                <img src="assets/images/icons/rightArrow.svg" alt="feedback-icon">
                            </div>

                            <div class="feedback-user">
                                <div class="user-avatar">
                                    <!-- You would typically use an image here -->
                                    <div class="avatar-placeholder">
                                        <img [src]="feedback.driverImg" alt="logo" />
                                    </div>
                                </div>
                                <div class="user-info">
                                    <div class="user-name">{{ feedback.driverName }}</div>
                                    <div class=" flex items-center">
                                        <span class="user-rating">★</span>
                                        <!-- <span class="text-[24px]">{{ feedback.rating.splice(0,1) }}</span> -->
                                        <span class="text-[20px]">{{ feedback.driverRating }}</span>

                                    </div>
                                </div>
                            </div>

                            <div class="star-rating">
                                <span *ngFor="let star of [1, 2, 3, 4, 5]" class="star"
                                    [class.active]="star <= (feedback.selectedRating || 0)"
                                    (click)="setRating(feedback, star)">
                                    ★
                                </span>
                            </div>

                            <div class="delivery-status" *ngIf="feedback.delivered">
                                <span class="delivered">Delivered</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>



        </div>
    </div>
</section>